import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-egg",
  "use": "icon-th-egg-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-egg\">\n<path d=\"M23.3325 7.445C21.0588 4.03625 18.3175 2 16 2C13.6825 2 10.9412 4.03625 8.6675 7.445C6.3375 10.9425 5 15.1537 5 19C5 21.9174 6.15893 24.7153 8.22183 26.7782C10.2847 28.8411 13.0826 30 16 30C18.9174 30 21.7153 28.8411 23.7782 26.7782C25.8411 24.7153 27 21.9174 27 19C27 15.1537 25.6625 10.9425 23.3325 7.445ZM16 28C13.6139 27.9974 11.3262 27.0483 9.63896 25.361C7.95171 23.6738 7.00265 21.3861 7 19C7 15.5387 8.215 11.7313 10.3325 8.555C12.1488 5.83 14.4263 4 16 4C17.5737 4 19.8512 5.83 21.6675 8.555C23.785 11.7313 25 15.5387 25 19C24.9974 21.3861 24.0483 23.6738 22.361 25.361C20.6738 27.0483 18.3861 27.9974 16 28Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-egg.svg
// module id = WieB
// module chunks = 84